import { Box, Container } from '@mui/system';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { ChoiceItem, ContinueButton } from '@europrocurement/flexy-components';
import { addressToString } from '@europrocurement/l2d-utils';
import { openIcon } from '@europrocurement/l2d-icons';
import { useParcoursFormalite } from '../provider/useParcoursFormalite';
import { parcoursFormalitePathResolver } from '../parcoursFormalitePathResolver';
import SelectionContact from '../components/SelectionContact';

const StepContact: React.FunctionComponent = function () {
    const navigate = useNavigate();

    const { prescripteur, containerWidth, contact, setContact } = useParcoursFormalite();

    if (!prescripteur) {
        throw new Error('Prescripteur is undefined in StepContact');
    }

    return (
        <Container maxWidth={containerWidth}>
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                }}
            >
                <Box>
                    <Typography
                        sx={{
                            paddingLeft: '15px',
                            paddingBottom: '8px',
                        }}
                        variant="l2dcaption"
                        color="text.secondary"
                    >
                        Prescripteur Sélectionné
                    </Typography>
                    <ChoiceItem
                        label={prescripteur.raisonSociale || ''}
                        idFiscal={prescripteur.siren || ''}
                        description={addressToString(prescripteur.adresses[0])}
                        isChecked
                        sx={{ width: 'calc(100% - 25px)' }}
                        value=""
                        updateItem={() => {
                            navigate(`/prescripteurs/liste/${prescripteur?.id}`);
                        }}
                        updateIcon={openIcon}
                        isDisabled={false}
                        invisibleCheckbox
                    />{' '}
                </Box>

                <SelectionContact
                    contact={contact}
                    setContact={setContact}
                    prescripteur={prescripteur}
                />
            </Box>
            <ContinueButton
                disabled={!prescripteur || !contact}
                onClick={() => {
                    navigate(parcoursFormalitePathResolver('stepFormalite'));
                }}
            />
        </Container>
    );
};
export default StepContact;
